// generic loading spinner, styled with the app's accent color
export default function Spinner({ className = "" }) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={`w-10 h-10 rounded-full border-4 border-border border-t-brand animate-spin ${className}`}
    />
  );
}
